import axios from "axios";
import { url } from "./config";
import errorToast from "../utils/toast/errorToast";

export const api = axios.create({
  baseURL: url,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error.response;
    if (response?.status === 400) {
      console.log("response", response, error);

      if (response?.data?.data === "logout") {
        errorToast("Unauthorized access. Token may be expired.");
        // localStorage.clear();
        // window.location.reload();
      }
    }

    return Promise.reject(error);
  },
);
